var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fpui-status-value"},[_vm._v(_vm._s(_vm.value)),(_vm.limit)?_c('span',[_vm._v("/"+_vm._s(_vm.limit))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }